import * as React from 'react';
import { NavLink } from 'react-router-dom';
import * as Dati from '../../Dati';
import * as Glob from "../../Globale";
import { ChiamaAPI, Trad, BaseComponent, Paginatore } from '../../components/';
import { PortletToogleIcon } from '../common/PortletToogleIcon';
import { TextEditor } from '../TextEditor';
import * as Dashboard from './Dashboard';

interface IDashboardNews {
    Page: number;
    Data: Array<Dati.CNews>;
    Aggiorna: number;
}

export class DashboardNews extends BaseComponent<{}, IDashboardNews> {
    private _PerPage: number = 3;

    public constructor(props: any) {
        super(props);
        this.state = { Page: 1, Data: [], Aggiorna: 1 };
        this.OnPageChange = this.OnPageChange.bind(this);
    }

    private OnResNews(sender: ChiamaAPI, dati: Dati.CRisAPILista<Dati.CNews>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.setState({Data: dati.Dati || []});
        }
        return false;
    }

    private OnPageChange(sender: Paginatore, page: number) {
        this.setState({ Page: page });
    }
    
    componentDidMount() {
        setInterval(() => { this.setState({ Aggiorna: this.state.Aggiorna + 1 }) }, Dashboard.SecondsAutomaticUpdate * 1000);
    }

    public render() {
        const pageItems = this.state.Data.slice(this.state.Page*this._PerPage-this._PerPage, this.state.Page*this._PerPage);

        return (
            <div className="kt-portlet portlet-shadow kt-portlet--sortable" data-ktportlet="true" >
                <div className="kt-portlet__head ui-sortable-handle">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-label">{Trad.Trad("News")}</h3>
                    </div>
                    <div className="kt-portlet__head-toolbar">
                        <PortletToogleIcon />
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <div className="kt-widget4">
                        {pageItems.map(item => (
                            <div className="kt-widget4__item" key={item.ID_News}>
                                <div className="kt-widget4__info kt-padding-r-0">
                                    <div className="kt-widget4-newsShorcut">
                                        <p className="kt-font-blod">{Trad.Trad(item.NewsDate)}</p>
                                        <h5 className="kt-font-bold kt-widget4__title text-right kt-padding-r-0">{item.Category}</h5>
                                    </div>
                                    <h5 className="kt-widget4__title kt-padding-t-10">{item.Title}</h5>
                                    <NavLink to={'/news/' + item.ID_News} className="text-right kt-padding-r-0 kt-widget4__icon">
                                        <p>{Trad.Trad("LeggiTutto") + "..."}</p>
                                    </NavLink>
                                </div>
                            </div>
                        ))}
                        <ChiamaAPI Aggiornare={this.state.Aggiorna}
                                   URL={"/api/news/GetLastTen"}
                                   OnRis={(s, d, dn) => this.OnResNews(s, d, dn)}
                                   OnErrore={this.OnErrore}
                                   ImmaginePrecaricamento={true} />
                    </div>
                    <Paginatore Pagina={this.state.Page} Pagine={4} OnCambioPagina={this.OnPageChange} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Dashboards/DashboardNews.tsx